export const getVideoId = (videoUrl: string): string => {
    let videoId = ``;
    if (!videoUrl) return videoId;
    const url = new URL(videoUrl);

    if (url.host === `youtu.be`) {
        videoId = url.pathname.replace(/\//g, ``);
    }
    if (url.pathname.includes(`shorts`) || url.pathname.includes(`live`)) {
        videoId = url.pathname.split(`/`)[2];
    }
    if (url.searchParams.has(`v`)) {
        videoId = url.searchParams.get(`v`);
    }
    return videoId;
};
